// import Papa from 'papaparse'

/**
* Read the file dropped
*/
const readFile = (pFile) => {
  const fileReader = new FileReader()

  return new Promise((resolve, reject) => {
    fileReader.onload = (pLoadFile) => {
      resolve(pLoadFile.target.result)
    }

    fileReader.readAsText(pFile)
  })
}

/**
* Check if the content of the file is
* in correct format.
*/
// const checkFile = (pFileText) => {}

export default readFile



// WEBPACK FOOTER //
// ./src/view/event/components/new-event/form-file-input/FileHandle.js